<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M11.5 26.628C6.55 26.162 2.665 21.58 2.665 16c0-5.89 4.328-10.666 9.667-10.666 4.241 0 7.845 3.014 9.147 7.207A7.083 7.083 0 1122 26.663v.005h-8.5V15.314l2.492 2.493a1 1 0 001.415-1.414l-4.267-4.267a1 1 0 00-1.414 0l-4.267 4.267a1 1 0 101.414 1.414l2.626-2.626v11.447z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'serverCloudFilled'
}
</script>
